<template>
    <div class="rest_list__item" :class="classItem" @click.prevent="clickItem">
        <checkbox_custom
            v-if="isOperationActive"
            :key="'checkbox_custom_' + itemId"
            :checkboxState="restItem.isCheck"
            @click_checkbox_custom="clickCheckboxCustom"
        />
        <div class="rest_list__item_rest_info">
            <div class="rest_list__item_rest_name">
                {{ restTitle }}
            </div>
            <div class="rest_list__item_rest_address">
                {{ restAddress }}
            </div>
        </div>

        <div v-if="isOperationActive" class="rest_list__item_active_list">
            <!--            <span class="rest_list__item_active_list_status" :class="classStatus">{{ locationStatus }}</span>-->
            <!--            <div class="rest_list__item_active_list_status_ico" :class="classStatus"></div>-->
            <button class="rest_list__item_active_list_button_enable" @click.prevent="clickOnline()">
                <spinner_button
                    v-if="isProcessOnline"
                    :key="'spinner_button_online'"
                    :color="colorSpinnerOnline"
                    :size="'20px'"
                />
                <svg v-else>
                    <use xlink:href="/icons/base.svg#icon_play"></use>
                </svg>
            </button>
            <button class="rest_list__item_active_list_button_disable" @click.prevent="clickOffline()">
                <spinner_button
                    v-if="isProcessOffline"
                    :key="'spinner_button_offline'"
                    :color="colorSpinnerOffline"
                    :size="'20px'"
                />
                <svg v-else>
                    <use xlink:href="/icons/base.svg#icon_pause"></use>
                </svg>
            </button>
        </div>

        <div v-if="isOperationSelect" class="rest_list__item_switch">
            <switch_block
                :key="'switch_block_'"
                :switchStatus="switchStatus"
                :width="52"
                :height="32"
                @click_switch="clickSwitch"
            />
        </div>
        <button v-else-if="isOperationStopList" class="rest_list__item_stop_list" >
            {{ __t('O.ADD_TO_STOP_LIST') }}
        </button>
        <button v-else-if="isOperationCourierList" class="rest_list__item_stop_list">
            {{ __t('O.GO_TO_COURIER_REGISTRATION') }}
        </button>
    </div>
</template>

<script>

import switch_block from "./SwitchBlock.vue";
import {createHelpers} from "vuex-map-fields";
import checkbox_custom from "../CheckboxCustom.vue";
import spinner_button from "../loader/SpinnerButton.vue";
import {colorFunctions} from "../../mixins/colorFunctions";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mAggregators} = createHelpers({
    getterType: 'aggregators/getAggregatorsField',
    mutationType: 'aggregators/updateAggregatorsField',
})

const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})

export default {
    name: "rest_list_item",
    props: {
        restItem: {
            type: Object,
            required: true,
        },
        operationName: {
            type: String,
            required: true,
        }
    },
    emits: ['click_switch_item', 'click_checkbox_item'],
    components: {checkbox_custom, switch_block, spinner_button},
    mixins: [colorFunctions],
    data() {
        return {
            isProcessOnline: false,
            isProcessOffline: false,
        }
    },
    beforeMount() {
        EventBus.$on('change_location_status', this.changeStatus);
        EventBus.$on('error_data', this.errorData);
    },
    beforeUnmount() {
        EventBus.$off('change_location_status', this.changeStatus);
        EventBus.$off('error_data', this.errorData);
    },
    methods: {
        clickItem() {
            if (this.isOperationStopList) {
                this.addStopList();
            }
            if (this.isOperationCourierList) {
                this.gotToCourierRegistration();
            }

        },
        errorData(actionName) {
            if (actionName === 'isProcessOnlineItem') {
                this.isProcessOnline = false;
            } else if (actionName === 'isProcessOfflineItem') {
                this.isProcessOffline = false;
            }

        },
        clickSwitch(switchStatus) {
            const params = {
                user: this.user,
                groupId: this.activeAggregator.id,
                locationId: this.restItem.id,
                location: this.restItem,
                state: switchStatus,
            }
            this.$emit('click_switch_item', params);
        },
        clickOnline() {
            this.isProcessOnline = true;
            const params = {
                user: this.user,
                location: this.restItem,
                status: 'online',
                actionName: 'isProcessOnlineItem'
            }
            this.clickStatus(params);
        },
        clickOffline() {
            this.isProcessOffline = true;
            const params = {
                user: this.user,
                location: this.restItem,
                beforeStatus: this.restItem.status,
                status: 'offline',
                actionName: 'isProcessOfflineItem'
            }
            this.clickStatus(params);
        },
        clickStatus(params) {
            this.$store.dispatch('aggregators/CHANGE_LOCATIONS_STATUS', params)
            //this.restItem.status = params.status;
        },
        clickCheckboxCustom() {
            this.$emit('click_checkbox_item', this.restItem);
        },
        changeStatus(params) {
            if (params.status === 'online' && this.restItem.id === params.location.id) {
                this.isProcessOnline = false;
                return;
            }
            if (params.status === 'offline' && this.restItem.id === params.location.id) {
                this.isProcessOffline = false;
            }
        },
        addStopList() {
            this.$router.push({name: 'ProductsStopList', params: {restId: this.restItem.id, backState: 0}})
        },
        gotToCourierRegistration() {
            this.$store.dispatch('couriers/SELECT_LOCATION_COURIER_NEW_REGISTRATION', this.restItem);
            this.$router.push({path: '/new/data'});
        }
    },
    computed: {
        ...mUser([
            'user',
            'errorMessageUser',
        ]),
        ...mAggregators([
            'activeAggregator',
        ]),
        ...mCouriers([
            'search_order',
        ]),
        restTitle() {
            if (this.restItem.title) {
                return this.restItem.title;
            }
            return 'No title'

        },
        restAddress() {
            if ((this.operationName === 'stop_list_locations' || this.operationName === 'courier_locations') && this.getObjectPathProperty(this.restItem, 'uniq_id')) {
                return this.getObjectPathProperty(this.restItem, 'uniq_id');
            }
            if (this.operationName === 'stop_list' && this.getObjectPathProperty(this.restItem, 'address')) {
                return this.getObjectPathProperty(this.restItem, 'address');
            }
            if (this.operationName !== 'stop_list' && this.getObjectPathProperty(this.restItem, 'linked_restaurant.address')) {
                return this.getObjectPathProperty(this.restItem, 'linked_restaurant.address');
            }
            return 'No address';
        },
        isOperationSelect() {
            return this.operationName === 'select_rest' || this.operationName === 'stop_list_locations';
        },
        isOperationActive() {
            return this.operationName === 'active_rest';
        },
        switchStatus() {
            return this.restItem.isSelect;
        },
        isOperationStopList() {
            return this.operationName === 'stop_list';
        },
        isOperationCourierList() {
            return this.operationName === 'courier_locations';
        },
        classStatus() {
            if (this.restItem.status && this.restItem.status === 'online') {
                return 'online';
            }
            return 'offline';
        },
        locationStatus() {
            if (this.restItem.status) {
                return this.restItem.status;
            }
            return '';
        },
        itemId() {
            if (this.restItem.id) {
                return this.restItem.id;
            }
            return '';
        },
        colorSpinnerOnline() {
            return this.darkerColorHex('#F6673C', 40);
        },
        colorSpinnerOffline() {
            return this.darkerColorHex('#979799', 40);
        },
        classItem() {
            if (this.isOperationStopList || this.isOperationCourierList) {
                return 'pointer';
            }
            return '';
        }
    }
}
</script>
